import {
  Truck,
  KeyRound,
  Zap,
  CircleDot,
  Clock,
  MapPin,
  MessageSquareText,
  ShieldCheck,
  Wrench,
} from "lucide-react";

export const COMPANY = "Paliway Towing, LLC";
export const PHONE_DISPLAY = "(682) 217-9734";
export const TEL_LINK = "tel:+16822179734";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CUANpDdB5qMHEAI/review";

export const smsLink = (msg) => `sms:16822179734?&body=${encodeURIComponent(msg)}`;
export const waLink = (msg) => `https://wa.me/16822179734?text=${encodeURIComponent(msg)}`;

export const DEFAULT_MSG =
  "Hi Paliway Towing! I need assistance in Tarrant County. My location is: ";

export const QUICK_SERVICES = [
  {
    id: "towing",
    label: "Light Duty Towing",
    icon: Truck,
    msg: "Hi Paliway Towing! I need a light duty tow in Tarrant County. My location is: ",
  },
  {
    id: "lockout",
    label: "Lockout Service",
    icon: KeyRound,
    msg: "Hi Paliway Towing! I'm locked out of my vehicle in Tarrant County. My location is: ",
  },
  {
    id: "jumpstart",
    label: "Battery Jumpstart",
    icon: Zap,
    msg: "Hi Paliway Towing! My battery is dead and I need a jumpstart in Tarrant County. My location is: ",
  },
  {
    id: "tire",
    label: "Tire Change",
    icon: CircleDot,
    msg: "Hi Paliway Towing! I have a flat tire and need a tire change in Tarrant County. My location is: ",
  },
];

export const SERVICES = [
  {
    id: "towing",
    title: "Light Duty Towing",
    icon: Truck,
    image: "/photos/tow-c.jpg",
    desc: "Safe wheel-lift or flatbed transport for sedans, coupes, lowered vehicles, and luxury cars — hooked, secured, and delivered without a scratch.",
    features: ["Wheel-lift or flatbed for lowered & luxury vehicles", "Sedans, coupes & light trucks", "Damage-free guarantee"],
  },
  {
    id: "roadside",
    title: "Roadside Assistance",
    icon: Wrench,
    image: "/photos/tire-change.jpg",
    fit: "contain",
    desc: "Quick response for vehicle lockouts, flat tire replacement, and dead battery jumpstarts — wherever you're stopped in Tarrant County.",
    features: ["Vehicle lockouts", "Flat tire replacement", "Battery jumpstarts"],
  },
  {
    id: "winch",
    title: "Winch-Out & Recovery",
    icon: ShieldCheck,
    image: "/photos/tow-winch.jpg",
    desc: "Pulling vehicles safely out of ditches, mud, or off-road situations with careful rigging and the right line angles.",
    features: ["Ditch & mud recovery", "Off-road winch-outs", "Careful, damage-free rigging"],
  },
  {
    id: "lockout",
    title: "Lockout & Jumpstart",
    icon: Zap,
    image: "/photos/jumpstart.jpg",
    desc: "Locked keys inside? Battery dead in a parking lot? We get you back behind the wheel in minutes, day or night.",
    features: ["Damage-free entry", "On-the-spot jumpstarts", "Day & night response"],
  },
];

export const TRUST_BADGES = [
  { icon: Clock, title: "24/7 Emergency Availability", desc: "Nights, weekends, holidays — dispatch never sleeps." },
  { icon: MapPin, title: "Tarrant County Local Experts", desc: "We know every highway, shortcut, and shoulder in the county." },
  { icon: MessageSquareText, title: "Rapid Response & Instant Text Dispatch", desc: "Text or WhatsApp your location and we're rolling." },
  { icon: ShieldCheck, title: "Licensed & Insured", desc: "Fully licensed and insured for total peace of mind." },
];

export const TESTIMONIALS = [
  {
    name: "Norsan Abdel",
    city: "Google Review",
    text: "Paliway Towing was fast and efficient, and he was incredibly nice. Got my car to its destination safely and quickly. Thank you so much, I will definitely recommend this service to others!",
  },
  {
    name: "Santiago Calderon",
    city: "Google Review",
    text: "Contracted through my insurance. Best service ever: I felt comfortable and safe. My service guy was friendly and attentive. I appreciate his service and friendly attitude. Simply the best.",
  },
  {
    name: "K M",
    city: "Google Review",
    text: "On time and was even early. Driver was very professional and knew exactly how I wanted my vehicle secured. Would recommend them without any reservation should you require a towing service.",
  },
];

export const CITIES = [
  "Fort Worth",
  "Arlington",
  "Grapevine",
  "Mansfield",
  "Euless",
  "Bedford",
  "Hurst",
  "Keller",
  "Southlake",
  "North Richland Hills",
  "Colleyville",
];

export const IMAGES = {
  hero: "/photos/tow-a.jpg",
  flatbed: "/photos/tow-c.jpg",
  night: "/photos/tow-e.jpg",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/service-area", label: "Service Area" },
  { to: "/gallery", label: "Recent Jobs" },
  { to: "/reviews", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];
